import { MenuEntry } from '@apeswapfinance/uikit'

export const BASE_APP_URL = process.env.REACT_APP_BASE_APP_URL || 'https://apeswap-frontend.vercel.app';

export const BASE_APP = 'https://app.cosmosium.finance';
const BASE_DEX = 'https://dex.cosmosium.finance';


export const links = [
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: `${BASE_DEX}/#/swap`,
      },
      {
        label: 'Liquidity',
        href: `${BASE_DEX}/#/pool`,
      },
    ],
  },
  {
    label: 'Earn',
    icon: 'FarmIcon',
    items : [
      {
        label : 'Cosmic',
        href : `${BASE_APP}/cosmic`
      },
      {
        label: 'Clusters',
        href: `${BASE_APP}/clusters`,
      },
      {
        label: 'Farms',
        href: `${BASE_APP}/farms`,
      },
    ]
  },
  {
    label: 'Indexes',
    icon: 'PoolIcon',
    href: `${BASE_APP}/indexes`,
  },
  // {
  //  label: 'Options',
  //  icon: 'FarmIcon',
  //  items : [
  //    {
  //      label: 'Call',
  //      href: '/options/call',
  //    },
  //    {
  //      label: 'Put',
  //      href: '/options/put',
  //    },
  //  ]
  // }, 
  // {
  //  label: 'IFO',
  //  icon: 'TicketIcon',
  //  href: '/ifo',
  // },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: '/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: '/nft',
  // },
  {
    label: 'Links',
    icon: 'MoreIcon',
    items: [
      {
        label: 'Github',
        href: 'https://github.com/cosmosiumfinance/',
      },
      {
        label: 'Docs',
        href: 'https://docs.cosmosium.finance/',
      },
      {
        label: 'Blog',
        href: 'https://medium.com/@cosmosiumfinance/',
      },
      {
        label: 'Telegram',
        href: 'https://t.me/cosmosiumfinance',
      },
    ],
  },
];

export const socials = [
  {
    label: "Telegram",
    icon: "TelegramIcon",
    items: [
      {
        label: "Global",
        href: "https://t.me/cosmosiumfinance",
      },
      // {
      //   label: "Bahasa Indonesia",
      //   href: "https://t.me/PancakeSwapIndonesia",
      // },
      {
        label: "Indian",
        href: "https://t.me/cosmosiumindia",
      },
      // {
      //   label: "Tiếng Việt",
      //   href: "https://t.me/PancakeSwapVN",
      // },
      {
        label: "Korean",
        href: "https://t.me/cosmosiumkorea",
      },
      // {
      //   label: "Português",
      //   href: "https://t.me/PancakeSwapPortuguese",
      // },
    ],
  },
  {
    label: "Twitter",
    icon: "TwitterIcon",
    href: "https://twitter.com/cosmosium",
  },
  {
    label: "Reddit",
    icon: "RedditIcon",
    href: "https://www.reddit.com/r/Cosmosium/",
  },
];